import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { useState } from "react";

const ChangePasswordDialog = ({ open, onClose, userId }) => {
  const { control, handleSubmit, reset } = useForm();
  const [showPassword, setShowPassword] = useState(false); // For toggling password visibility
  const apiUrl = process.env.REACT_APP_GRAPHQL_ENDPOINT;

  // Toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // Handle form submission for changing password
  const onSubmit = async (data) => {
    try {
      const mutation = `
        mutation ChangePassword($userId: ID!, $currentPassword: String!, $newPassword: String!) {
          changePassword(userId: $userId, currentPassword: $currentPassword, newPassword: $newPassword) {
            success
            message
          }
        }
      `;
      const variables = {
        userId,
        currentPassword: data.currentPassword,
        newPassword: data.newPassword,
      };
      const response = await axios.post(apiUrl, {
        query: mutation,
        variables,
      });

      console.log(
        "Password changed successfully:",
        response.data.data.changePassword
      );

      // Close the dialog after successful change
      onClose();
    } catch (error) {
      console.error("Error changing password:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                name="currentPassword"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Current Password"
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    {...field}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="newPassword"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="New Password"
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    {...field}
                  />
                )}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          variant="contained"
          color="primary"
        >
          Change Password
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordDialog;
